import React from 'react';
// import Image from 'next/image';

import DropdownItem from './DropdownItem';
import { dropdownItems } from './Content';

const NavMobile = ({ theme, navResponsive }) => (
  <div>
    <h4 className={`${theme.dropdown.title} block uppercase text-xs tracking-wider`}>Products</h4>
    <ul
      className={`grid grid-cols-2  gap-y-4 mt-4 pb-4 border-b ${theme.dropdown.border}`}
      style={{ gridTemplateColumns: '52% 48%' }}
    >
      {dropdownItems.products.annotate.content.map(item => (
        <DropdownItem
          key={item.title}
          href={item.href}
          icon={item.icon}
          title={item.title}
          text={item.text}
          colors={theme.dropdown.items}
          itemType={item.type}
          navResponsive={navResponsive}
        />
      ))}
      {dropdownItems.products.others.map(item => (
        <DropdownItem
          key={item.content.title}
          href={item.content.href}
          icon={item.content.icon}
          title={item.content.title}
          text={item.content.text}
          colors={theme.dropdown.items}
          itemType={item.content.type}
          navResponsive={navResponsive}
        />
      ))}
      {dropdownItems.products.othersSecondColumn && (
        <>
          {dropdownItems.products.othersSecondColumn.map(item => (
            <DropdownItem
              key={item.content.title}
              href={item.content.href}
              icon={item.content.icon}
              title={item.content.title}
              text={item.content.text}
              colors={theme.dropdown.items}
              itemType={item.content.type}
              navResponsive={navResponsive}
            />
          ))}
        </>
      )}
      {/* {navResponsive && (
        <DropdownItem
          key="Scale Rapid"
          href="/rapid"
          icon={
            <Image
              src="/static/images/pages/rapid/rapid-logo.svg"
              layout="responsive"
              alt="Scale Rapid"
              width={70}
              height={70}
              quality="100"
              priority
            />
          }
          title="Scale Rapid"
          colors={theme.dropdown.items}
          itemType="big"
          navResponsive={navResponsive}
        />
      )} */}
    </ul>
    <h4 className={`${theme.dropdown.title} block mt-4 uppercase text-xs tracking-wider`}>
      Solutions
    </h4>
    <ul
      className={`grid grid-cols-2 gap-y-4 mt-4 pb-4 border-b ${theme.dropdown.border}`}
      style={{ gridTemplateColumns: '52% 48%' }}
    >
      {dropdownItems.solutions.industries.content.map(item => (
        <DropdownItem
          key={item.title}
          href={item.href}
          icon={item.icon}
          title={item.title}
          text={item.text}
          colors={theme.dropdown.items}
          itemType={item.type}
          navResponsive={navResponsive}
        />
      ))}
      {dropdownItems.solutions.useCases.content.map(item => (
        <DropdownItem
          key={item.title}
          href={item.href}
          icon={item.icon}
          title={item.title}
          text={item.text}
          colors={theme.dropdown.items}
          itemType={item.type}
          navResponsive={navResponsive}
        />
      ))}
    </ul>
    <h4 className={`${theme.dropdown.title} block mt-4 uppercase text-xs tracking-wider`}>
      Resources
    </h4>
    <ul
      className={`grid grid-cols-2 gap-y-4 mt-4 pb-4 border-b ${theme.dropdown.border}`}
      style={{ gridTemplateColumns: '52% 48%' }}
    >
      {dropdownItems.resourcesMobile.map(item => (
        <DropdownItem
          key={item.title}
          href={item.href}
          icon={item.icon}
          title={item.title}
          text={item.text}
          colors={theme.dropdown.items}
          itemType={item.type}
          navResponsive={navResponsive}
        />
      ))}
    </ul>
    <h4 className={`${theme.dropdown.title} block mt-4 uppercase text-xs tracking-wider`}>
      Company
    </h4>
    <ul className="grid grid-cols-2 mt-4 gap-y-4" style={{ gridTemplateColumns: '53% 47%' }}>
      {dropdownItems.company.map(item => (
        <DropdownItem
          key={item.title}
          href={item.href}
          icon={item.icon}
          title={item.title}
          text={item.text}
          colors={theme.dropdown.items}
          itemType={item.type}
          navResponsive={navResponsive}
        />
      ))}
    </ul>
  </div>
);

export default NavMobile;
